export default __webpack_public_path__ + "static/media/content-illustration_neighborhood.01214c3a.svg";